const TWO_FACTOR_ERROR_I18N_KEYS = {
  'invalid credentials': 'auth.login.auth-error',
  'invalid code': 'auth.login.two-factor-invalid',
  'permission denied': 'auth.login.two-factor-permission-denied',
};

function isTwoFactorChallengeAccessInvalid(accessTokenField) {
  const raw = accessTokenField;
  const msg = Array.isArray(raw) ? raw[0] : raw;
  if (typeof msg !== 'string') {
    return false;
  }
  const normalized = msg.toLowerCase();
  return normalized.includes('expired access token') || normalized.includes('invalid access token');
}

/**
 * Maps POST /auth/two-factor error payload (English) to a translated message.
 * @param {object|undefined} apiErrorData
 * @param {(key: string) => string} t
 * @returns {string}
 */
export function resolveTwoFactorApiError(apiErrorData, t) {
  const errorMessage = apiErrorData?.error;
  if (typeof errorMessage === 'string' && errorMessage.trim()) {
    const i18nKey = TWO_FACTOR_ERROR_I18N_KEYS[errorMessage.trim().toLowerCase()];
    if (i18nKey) {
      return t(i18nKey);
    }
    return errorMessage;
  }

  if (isTwoFactorChallengeAccessInvalid(apiErrorData?.access_token)) {
    return t('auth.login.two-factor-challenge-expired');
  }

  return t('auth.login.two-factor-invalid');
}
